<template>
  <div
    v-if="
      neopassDatas[constants.PAGE_NEOPASS_FORM_PROJETS] &&
      neopassDatas[constants.PAGE_NEOPASS_FORM_PROJETS].length > 0
    "
  >
    <h3 class="xl:my-15 text-center">Plan d'accompagnement</h3>
    <div class="grid grid-cols-1 md:grid-cols-2 space-y-10">
      <div class="col-span-1">
        <doughnut
          id-chart="typeProjet"
          title="Type"
          :labels="types.labels"
          :values="types.datas"
          thickness="70"
          :colors="color('eightColors')"
          position-legend="bottom"
          height="400"
          width="400"
        />
      </div>
      <div class="col-span-1">
        <doughnut
          id-chart="dureeAccompagnement"
          title="Durée des accompagnements (h)"
          :labels="dureeAccompagnement.labels"
          :values="dureeAccompagnement.datas"
          thickness="70"
          :colors="color('eightColors')"
          position-legend="bottom"
          height="400"
          width="400"
        />
      </div>
      <div class="col-span-1">
        <doughnut
          id-chart="experiences"
          title="Experiences"
          :labels="experiences.labels"
          :values="experiences.datas"
          thickness="70"
          :colors="color('eightColors')"
          position-legend="bottom"
          height="400"
          width="400"
        />
      </div>
      <div class="col-span-1">
        <doughnut
          id-chart="etats"
          title="Etats des décisions"
          :labels="etats.labels"
          :values="etats.datas"
          thickness="70"
          :colors="color('eightColors')"
          position-legend="bottom"
          height="400"
          width="400"
        />
      </div>
    </div>
  </div>
  <div v-else class="text-center mt-1/10 text-gray-600">
    Aucune donnée à afficher.
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Bar from '../../../components/Charts/Bar';
import Doughnut from '../../../components/Charts/Doughnut.vue';

import Constants from './../../../constants';

export default {
  components: {
    Icon,
    ActionButton,
    Bar,
    Doughnut,
  },

  name: 'CartoColPlanAccompagnement',

  data() {
    return {
      constants: Constants,
    };
  },

  mounted() {
    //
  },

  methods: {
    ...mapMutations({
      //
    }),
    color(c) {
      if (c == 'indigo') {
        return '#3A18D1';
      } else if (c == 'pink') {
        return '#FF1C80';
      } else if (c == 'twelveColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
          '#CE5AE3',
          '#F9A1D4',
        ];
      } else if (c == 'elevenColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
          '#CE5AE3',
        ];
      } else if (c == 'tenColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
        ];
      } else if (c == 'nineColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
        ];
      } else if (c == 'eightColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
        ];
      } else if (c == 'evaluation') {
        return [
          '#FBE6F0',
          '#FEF3F8',
          '#FFEDE3',
          '#FFF6F1',
          '#DFE0F2',
          '#FAF7FC',
          '#EAF5F6',
          '#D3F1F5',
        ];
      }
    },
  },
  computed: {
    ...mapGetters({
      neopassDatas: 'cartographiesCollectives/neopassDatas',
    }),

    datas: function () {
      return this.neopassDatas[Constants.PAGE_NEOPASS_FORM_PROJETS].reduce(
        (acc, projet) => [...acc, ...projet.projets],
        []
      );
    },

    types() {
      let datas = this.datas
        .map((projet) => projet.type_projet)
        .reduce(
          (acc, projet) => (
            acc[projet] ? ++acc[projet] : (acc[projet] = 1), acc
          ),
          {}
        );

      return {
        labels: Object.keys(datas),
        datas: Object.values(datas),
      };
    },

    dureeAccompagnement() {
      let datas = this.datas.reduce(
        (acc, projet) => (
          acc[projet.type_projet]
            ? (acc[projet.type_projet] += parseInt(
                projet.total_temps_accompagnement
              ))
            : (acc[projet.type_projet] = parseInt(
                projet.total_temps_accompagnement
              )),
          acc
        ),
        {}
      );

      return {
        labels: Object.keys(datas),
        datas: Object.values(datas),
      };
    },

    experiences() {
      let datas = this.datas
        .map((projet) => projet.periodes.map((periode) => periode.type).flat())
        .flat()
        .reduce(
          (acc, periode) => (
            acc[periode] ? ++acc[periode] : (acc[periode] = 1), acc
          ),
          {}
        );

      return {
        labels: Object.keys(datas),
        datas: Object.values(datas),
      };
    },

    etats() {
      let datas = this.datas
        .map((projet) =>
          projet.etat_decision_projet
            ? projet.etat_decision_projet
            : 'Non précisé'
        )
        .flat()
        .reduce(
          (acc, projet) => (
            acc[projet] ? ++acc[projet] : (acc[projet] = 1), acc
          ),
          {}
        );

      return {
        labels: Object.keys(datas),
        datas: Object.values(datas),
      };
    },
  },
};
</script>
